import { FaBars, FaUser, FaCog, FaSignOutAlt } from "react-icons/fa";
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { onErrorLogout } from "../_config/authService";
import profile from "../assets/img/profile.jpg";
import { makeRequestAuth } from "../_config/api";
import { showErrorToast } from "../utils/toastUtils";

function Header({ onToggleSidebar, sidebarOpen }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [profiles, setProfile] = useState(null);

  const fetchProfile = async () => {
    try {
      const res = await makeRequestAuth("post", "/admin/adminprofile");

      if (res?.error === false) {
        setProfile(res.data);
      } else {
        showErrorToast(res?.message || "Unable to load profile!");
      }
    } catch (error) {
      showErrorToast(error?.message || "Server error!");
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header
      className={`bg-white dark:bg-[#071225] text-gray-900 dark:text-white fixed top-0 right-0 z-20 flex items-center justify-between 
    px-4 sm:px-6 py-3 shadow-sm transition-all duration-700 ease-in-out w-full
    ${sidebarOpen ? "lg:ml-64 lg:w-[calc(100%-16rem)]" : "lg:ml-0 lg:w-full"}`}
    >
      {/* Left */}
      <div className="flex items-center space-x-3">
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none"
        >
          <FaBars size={20} />
        </button>

        <h1 className="hidden sm:block text-lg sm:text-2xl font-bold text-gray-900 dark:text-white">
          Welcome, Admin
        </h1>
      </div>

      {/* Right */}
      <div className="flex items-center space-x-4 sm:space-x-6">
        {/* <Search />
        <Notifications /> */}
        {/* <ThemeToggle /> */}
        <div className="relative" ref={menuRef}>
          <div
            onClick={() => setMenuOpen(!menuOpen)}
            className="flex items-center space-x-2 cursor-pointer 
             sm:hover:bg-gray-100 sm:dark:hover:bg-gray-700 
             px-2 py-1 rounded-lg transition-colors"
          >
            {/* <span className="hidden sm:inline text-gray-700 dark:text-gray-200 font-medium text-sm capitalize">
              {profiles?.name}
            </span> */}
            <div className="w-8 h-8 rounded-full bg-green-200 flex items-center justify-center text-sm font-bold text-green-700">
              <img
                src={profiles?.image || profile}
                alt="Profile"
                className="w-7 h-7 rounded-full border-1 border-teal-600 object-cover"
              />
            </div>
          </div>

          {menuOpen && (
            <div
              className="absolute right-0 mt-3 w-52 bg-white dark:bg-[#1E2335]
    rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.15)] overflow-hidden 
    border border-gray-100 dark:border-white/10 
    animate-dropdown z-50"
            >
              {/* PROFILE */}
              <Link
                to="/settings/profile"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 
      text-gray-700 dark:text-gray-200 
      hover:bg-gray-100 dark:hover:bg-white/10 transition"
              >
                <FaUser className="text-blue-500 text-lg" />
                <span className="text-sm font-medium">Profile</span>
              </Link>

              {/* SETTINGS */}
              <Link
                to="/settings/profile"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 
      text-gray-700 dark:text-gray-200 
      hover:bg-gray-100 dark:hover:bg-white/10 transition"
              >
                <FaCog className="text-sky-500 text-lg" />
                <span className="text-sm font-medium">Settings</span>
              </Link>

              {/* DIVIDER */}
              <div className="border-t border-gray-200 dark:border-white/10"></div>

              {/* LOGOUT */}
              <button
                onClick={() => {
                  setMenuOpen(false);
                  setShowLogoutPopup(true);
                }}
                className="flex items-center gap-3 w-full text-left px-4 py-3 
      text-red-600 dark:text-red-400 
      hover:bg-red-100 dark:hover:bg-red-700/30 transition"
              >
                <FaSignOutAlt className="text-red-500 dark:text-red-400 text-lg" />
                <span className="text-sm font-medium">Logout</span>
              </button>
            </div>
          )}
        </div>
        {showLogoutPopup && (
          <div className="fixed inset-0 bg-black/60 z-[999] flex justify-center items-center">
            <div className="bg-[#0B1324] text-center p-8 rounded-2xl w-[90%] sm:w-[420px] shadow-xl">
              <h2 className="text-2xl font-semibold text-white mb-4">
                Logout Confirmation
              </h2>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                Are you sure you want to log out?
                <br />
                You will be signed out from the Super Admin panel.
              </p>

              <div className="flex justify-center gap-4">
                <button
                  onClick={() => setShowLogoutPopup(false)}
                  className="bg-white text-black px-6 py-3 rounded-lg w-32 font-medium hover:bg-gray-200 transition"
                >
                  Cancel
                </button>

                <button
                  onClick={() => onErrorLogout()}
                  className="bg-red-600 text-white px-6 py-3 rounded-lg w-32 font-medium hover:bg-red-700 transition"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
